// 🔧 sap_ai_agents_challenge_entry_generator.js
// ✅ Purpose: Generates SAP AI Agents Challenge partner entries for the LGV Legacy Experience Factory
// ✅ Features:
// - Generates partner entries from the registered SAP Experience manifest
// - Supports exactly thirteen fictional partner teams
// - Assigns stable SAP-01 through SAP-13 entry identifiers for QR-oriented demos
// - Places all partners in the single AI Agents Challenge category
// - Uses existing generic entry fields so no Firestore schema change is required
// - Does not create scoring criteria or judged evaluations; those belong to 5C and 5D
// - Fully block-commented for clarity and future devs

import {
  getIndustryTemplate,
} from "../industries";

import {
  generateRegistrationNumber,
} from "./registration_generator";
import { generateImagesForEntry } from "./image_generator";

export const generateSapAiAgentsChallengeEntries = ({
  count = 13,
  categories = [],
} = {}) => {
  const industry =
    getIndustryTemplate(
      "sap_ai_agents_challenge"
    );

  if (!industry?.entries?.length) {
    throw new Error(
      "SAP AI Agents Challenge Experience has no registered partner entries."
    );
  }

  const requestedCount =
    Math.min(
      Math.max(Number(count) || 0, 0),
      industry.entries.length
    );

  const category =
    typeof categories[0] === "string"
      ? categories[0]
      : categories[0]?.name ||
        industry.categories?.[0]?.name ||
        "AI Agents Challenge";

  return industry.entries
    .slice(0, requestedCount)
    .map((partner, index) => {
      const partnerNumber =
        index + 1;

      const title =
        partner.partnerName;

      const imageData = generateImagesForEntry({
        entry: { title },
        industryKey: "sap_ai_agents_challenge",
      });

      return {
        demoSeed: true,

        regcnt:
          generateRegistrationNumber({
            industryKey:
              "sap_ai_agents_challenge",

            index,
          }),

        title,

        name: title,

        // ===================================================
        // Generic Legacy Entry Builder compatibility
        // ===================================================
        // Legacy entry persistence still contains optional
        // vehicle-oriented fields. Supplying empty values keeps
        // SAP entries compatible without adding a new schema.
        // ===================================================

        year: "",

        make: "",

        model: "",

        color: "",

        ownerName:
          partner.partnerName,

        ownerFirstName: "",

        ownerLastName: "",

        ownerCity:
          "Milan",

        ownerState: "",

        categoryName:
          category,

        description:
          partner.description,

        focusArea:
          partner.focusArea,

        socialLinks: [],

        imgUrl: imageData.thumbnail,

        imageUrl: imageData.thumbnail,

        images: imageData.gallery,

        imagePlaceholder: imageData.placeholder,

        imageSource: imageData.source,

        imageAltText: imageData.altText,

        imageAltText:
          `${partner.partnerName} AI Agents Challenge partner entry`,

        displayOrder:
          partnerNumber,
      };
    });
};
